import { render, staticRenderFns } from "./InstanceExporter.vue?vue&type=template&id=2188d524&"
import script from "./InstanceExporter.vue?vue&type=script&lang=js&"
export * from "./InstanceExporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports